export default __webpack_public_path__ + "static/media/lock.d0ffce9f.svg";